import {Component, ViewEncapsulation} from '@angular/core';
import {ReactiveFormsModule} from "@angular/forms";
import {ImagePathConstants, RoutesConstants} from "@coreconstant";
import {RouterModule} from '@angular/router';
import {SeoService} from '../../core/services/common-service/seo.service';
import {WeddingPlanCtaComponent} from '../../core/component/common/wedding-plan-cta/wedding-plan-cta.component';
import {FaqCtaComponent} from '../../core/component/common/faq-cta/faq-cta.component';
import {MetaDataConstants} from '../../core/constants/meta-data-constants';

@Component({
    selector: 'app-contact-us',
    imports: [RouterModule, ReactiveFormsModule, WeddingPlanCtaComponent, FaqCtaComponent],
    templateUrl: './contact-us.component.html',
    styleUrl: './contact-us.component.scss',
    encapsulation: ViewEncapsulation.None
})

export class ContactUsComponent {
    imagePathConstants = ImagePathConstants
    routesConstants = RoutesConstants;

    constructor(
        private _seoService: SeoService,
    ) {
        this.setMetaTags()
    }

    /**
     * Sets the meta tags for the current page by creating a meta tag object and passes it to the SEO service for application.
     * @return {void} Does not return a value.
     */
    setMetaTags() {
        let metaTagObject = {
            title: MetaDataConstants.CONTACT_US.TITLE,
            description: MetaDataConstants.CONTACT_US.DESCRIPTION,
            ogImageUrl: MetaDataConstants.CONTACT_US.OGIMAGEURL,
            ogWebUrl: this.routesConstants.HOW_IT_WORKS_CONTACT_US_NAVIGATION,
        }
        this._seoService.setMetaTags(metaTagObject)
    }
}
